import type { ComponentSingleStyleConfig } from '@chakra-ui/react';

const themedCheckbox: ComponentSingleStyleConfig = {
    baseStyle: (props) => ({
        transition: 'none',
        control: {
            borderColor: props.colorMode === 'light' ? 'gray.400' : 'gray.500',
        },
        label: {
            marginLeft: '0.675rem',
        },
    }),
};

export default themedCheckbox;
